<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-row>
        <v-col class="pa-0 grow">
          <v-card flat color="transparent">
            <v-card-title class="d-flex align-baseline">
              ตั้งค่า
              <span v-if="surveyform.updated_date" class="ml-4 font-italic"
                ><h6>
                  แก้ไขครั้งล่าสุด :
                  {{
                    $store.getters.datetimeConvertShort(surveyform.updated_date)
                  }}
                </h6></span
              ></v-card-title
            >
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-form ref="form">
        <v-card class="my-3">
          <!-- <v-card-title style="font-size: 16px" class="py-0">
            Webform URL :
            <v-text-field
              hide-details
              outlined
              dense
              ref="link"
              class="pa-4"
              readonly
              :value="decodeURI(url)"
              @click="copy"
            ></v-text-field>
            <v-btn color="#1184bd" icon @click="copy"
              ><v-icon class="mx-3">content_copy</v-icon></v-btn
            >
          </v-card-title> -->
          <v-card-title style="font-size: 16px">
            <v-row no-gutters>
              <v-col cols="2"> Webform URL :</v-col>
              <v-col cols="9">
                {{ decodeURI(url) }}
              </v-col>
              <v-col cols="1" class="d-flex justify-center"
                ><v-btn
                  color="#1184bd"
                  icon
                  @click="
                    $store.getters.CopyText(decodeURI(url)), (snackbar = true)
                  "
                  ><v-icon>content_copy</v-icon></v-btn
                ></v-col
              >
            </v-row>
          </v-card-title>

          <!-- <v-card-text>
            <v-checkbox
              v-model="surveyform.welcome_theme.default.autoform"
              label="แบบสอบถามแบบไม่ระบุตัวตน"
              hint="จะใช้งานได้เมื่อไม่ได้อยู่ในเงื่อนไขยืนยันตัวตน"
              :persistent-hint="surveyform.welcome_theme.default.autoform"
              @click.stop="ToggleAutoForm()"
            ></v-checkbox>
          </v-card-text> -->
        </v-card>
        <v-card class="mb-3">
          <General
            :surveyform="surveyform"
            @submit="UpdateSurvey"
            @getSurveyByID="getSurveyByID"
          />
          <DatetimeClose
            :surveyform="surveyform"
            @submit="UpdateSurvey"
            @setstartend="Schedule"
          />
          <FormSetting :surveyform="surveyform" @submit="UpdateSurvey" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!SPermission.update"
              color="#033666"
              @click="UpdateSurvey"
              dark
            >
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-card class="d-flex justify-start align-center pa-3">
        ลบแบบสอบถาม
        <v-btn
          @click="DeleteSurvey()"
          small
          class="mx-2 white--text"
          color="#DE4F3B"
          :disabled="!SPermission.delete"
          >ลบ</v-btn
        >
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="2000">
        คัดลอกเรียบร้อย
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            ปิด
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DatetimeClose from "../../components/SettingUI/DatetimeClose.vue";
import FormSetting from "../../components/SettingUI/FormSetting.vue";
import General from "../../components/SettingUI/General.vue";
export default {
  components: { DatetimeClose, FormSetting, General },
  mounted() {
    this.getSurveyByID();
  },
  created() {
    this.$store.dispatch("CheckPermission").then((resp_role) => {
      if (resp_role.data.permission) {
        if (Object.keys(resp_role.data.permission).length !== 0) {
          this.$store.commit("UpdateUserPermission", resp_role.data);
          if (
            !Object.values(resp_role.data.permission.survey).every(
              (value) => !value
            )
          ) {
            this.$vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: "easeInOutCubic",
            });
            this.$store.dispatch("getPermission");
            this.$store.dispatch("getRole");
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$router.push({
                name: "question",
              });
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
            title: "",
          }).then(() => {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            this.$router.push({
              name: "question",
            });
          });
        }
      }
    });
  },
  data() {
    return {
      url: `${window.location.origin}${process.env.VUE_APP_SUBDOMAIN}startform?surveyID=${this.$route.params.surveyID}`,
      copied: false,
      snackbar: false,
      surveyform: {
        surveyID: "",
        surveyStatus: "",
        surveyName: "",
        surveyDetail: "",
        enableSchedule: false,
        surveyCoverPic: "",
        surveyDatetimeStart: "",
        surveyDatetimeEnd: "",
        enableAuth: false,
        enableOneTime: false,
        enableAutoForm: false,
        webform_theme: {
          bg_color: "#FBFBFBFF",
          bg_image: false,
          bg_image_url: "",
          bg_repeat: "repeat",
          bg_position_x: "left",
          bg_position_y: "top",
          bg_size: "auto",
          header_bg: "#395DA5FF",
          header_text: "#FFFFFFFF",
          title: "",
          subtitle: "",
          logo: false,
          logo_type: "normal",
          banner_size: 100,
          logo_image: {
            url: "",
            size: 50,
            rounded: "circle",
            align: "center",
            margin: true,
          },
          checkbox_row: false,
          radio_row: false,
          q_bgcolor: "#FFFFFFFF",
          q_text_color: "#000000",
          q_border_px: 1,
          q_border_color: "#0000001f",
          ans_color: "#395da5",
          ans_bgcolor: "#FFFFFFFF",
          ans_text_color: "#000000",
          ans_border_px: 1,
          ans_border_color: "#0000001f",
          button: {
            bg_color: "#395DA5FF",
            text: "ถัดไป >>",
            text_color: "#FFFFFFFF",
            bt_texttype: "button",
          },
          restart_button: {
            bg_color: "#395DA5FF",
            text: "เริ่มใหม่",
            text_color: "#395DA5",
            bt_texttype: "outlined",
          },
        },
        welcome_theme: {
          bg_color: "#FBFBFBFF",
          bg_image: false,
          bg_image_url: "",
          bg_repeat: "repeat",
          bg_position_x: "left",
          bg_position_y: "top",
          bg_size: "auto",
          image: false,
          image_url:
            "https://chatme04.chatme.co.th/CMStorage/086672a7-dfa4-5ffc-b1fc-d5a148c0175b1643613845347.png",
          image_size: "100%",
          wc_fullwidth: false,
          wc_color: "#FFFFFFFF",
          wc_bg_title: "#FFFFFFFF",
          wc_title: "#395DA5FF",
          wc_subtitle: "#00000099",
          wc_justify: "start",
          default: {
            field_color: "#395DA5FF",
            field_bg: "#f0f0f0",
            field_label: "ชื่อผู้ทำแบบสอบถาม",
            field_dense: true,
            field_type: "outlined",
            button: {
              bg_color: "#395DA5FF",
              text: "เริ่มทำแบบสอบถาม",
              text_color: "#FFFFFFFF",
              bt_texttype: "button",
              bt_block: true,
              bt_rounded: true,
            },
            autoform: false,
          },
          notintime: {
            counting_color: "#F44336",
            counting_early_text: "แบบสอบถามนี้จะเปิดรับคำตอบในอีก",
            counting_early_color: "#000000",
            counting_end_text: "แบบสอบถามนี้หมดเวลารับคำตอบแล้ว",
            counting_end_color: "#F44336",
            text_justify: "center",
            swap_counting: false,
            swap_end: false,
          },
          oneid: {
            login_button: {
              bg_color: "#395DA5FF",
              text: "เข้าสู่ระบบผ่าน ONEID",
              text_color: "#FFFFFFFF",
              bt_texttype: "button",
              bt_block: true,
              bt_rounded: true,
            },
            showreg: true,
            showreg_btn: true,
            texttoreg: "คุณยังไม่มีบัญชี OneID ใช่หรือไม่ ?",
            texttoreg_color: "#00000099",
            reg_button: {
              bg_color: "#395DA5FF",
              text: "ลงทะเบียน OneID",
              text_color: "#395DA5FF",
              bt_texttype: "outlined",
              bt_block: true,
              bt_rounded: true,
            },
          },
          closed: {
            close_text: "แบบสอบถามนี้ปิดรับคำตอบแล้ว",
            close_text_color: "#F44336",
            text_justify: "center",
            swap_title: false,
          },
        },
        endform_theme: {
          bg_color: "#FBFBFBFF",
          bg_image: false,
          bg_image_url: "",
          bg_repeat: "repeat",
          bg_position_x: "left",
          bg_position_y: "top",
          bg_size: "auto",
          image: false,
          image_url:
            "https://chatme04.chatme.co.th/CMStorage/endform_1628063085970.png",
          image_size: 400,
          text_color: "#000000",
          text_justify: "center",
          text_size: 30,
          button: {
            bg_color: "#395DA5FF",
            text: "ทำแบบทดสอบอีกครั้ง",
            text_color: "#FFFFFFFF",
            bt_texttype: "button",
            bt_block: false,
            bt_rounded: false,
          },
        },
        updated_date: "",
      },
    };
  },
  computed: {
    SPermission() {
      return this.$store.state.user_permission.survey;
    },
  },
  methods: {
    getSurveyByID() {
      this.$store
        .dispatch("getSurveyByID", this.$route.params.surveyID)
        .then((response) => {
          // console.log(response.data);
          let form = {
            surveyID: response.data.surveyID,
            surveyStatus: response.data.surveyStatus,
            surveyName: response.data.surveyName,
            surveyDetail: response.data.surveyDetail,
            enableSchedule: response.data.enableSchedule,
            surveyCoverPic: response.data.surveyCoverPic,
            surveyDatetimeStart: this.$store.getters.datetimeISOString(
              response.data.surveyDatetimeStart
            ),
            surveyDatetimeEnd: this.$store.getters.datetimeISOString(
              response.data.surveyDatetimeEnd
            ),
            enableAuth: response.data.enableAuth,
            enableOneTime: response.data.enableOneTime,
            enableAutoForm: false,
            updated_date: response.data.updated_date,
          };
          if (response.data.webform_theme) {
            form.webform_theme = response.data.webform_theme;
          }
          if (response.data.welcome_theme) {
            form.welcome_theme = response.data.welcome_theme;
            if (!Object.keys(form.welcome_theme.default).includes("autoform")) {
              form.welcome_theme.default.autoform = false;
            }
          }
          if (response.data.endform_theme) {
            form.endform_theme = response.data.endform_theme;
          }
          this.surveyform = form;
        });
    },
    UpdateSurvey() {
      this.surveyform.surveyName = this.surveyform.surveyName.trim();
      if (this.$refs.form.validate() && this.surveyform.surveyName) {
        this.$store.commit("ToggleButtonLoading");
        if (!this.surveyform.enableSchedule) {
          this.surveyform.surveyDatetimeStart = "";
          this.surveyform.surveyDatetimeEnd = "";
        }
        this.$store
          .dispatch("UpdateSurvey", this.surveyform)
          .then(() => {
            Swal.fire({
              icon: "success",
              text: "แก้ไขเรียบร้อยแล้ว",
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              if (
                this.$route.params.surveyName !== this.surveyform.surveyName
              ) {
                this.$router.push({
                  name: "setting",
                  params: {
                    surveyID: this.$route.params.surveyID,
                    surveyName: this.surveyform.surveyName,
                  },
                });
              }
              this.$store.dispatch("getSurvey");
              this.getSurveyByID();
              this.$store.commit("ToggleButtonLoading");
            });
          })
          .catch((err) => {
            let errMsg =
              err.data.message === "Permission Denied"
                ? "คุณไม่มีสิทธิ์แก้ไข survey"
                : "ไม่สามารถแก้ไขได้";
            Swal.fire({
              icon: "error",
              text: errMsg,
              title: "",
            }).then(() => {
              this.$store.dispatch("getSurvey");
              this.$store.commit("ToggleLoading");
              if (err.data.message === "Permission Denied") {
                this.$store
                  .dispatch(
                    "getQuestionPermission",
                    this.$route.params.surveyID
                  )
                  .then(() => {
                    this.$router.push({
                      name: "question",
                    });
                  });
              }
            });
          });
      } else {
        Swal.fire({
          icon: "warning",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }
    },
    copy() {
      const markup = this.$refs.link;
      markup.focus();
      document.execCommand("selectAll", false, null);
      this.copied = document.execCommand("copy");
      this.snackbar = true;
    },
    DeleteSurvey() {
      Swal.fire({
        html: `${
          this.surveyform.surveyStatus
            ? "แบบสอบถามนี้ถูก<span style='font-weight: bold;text-decoration: underline'>เปิดใช้งาน</span>แล้ว<br>"
            : ""
        }ยืนยันการลบ "${this.surveyform.surveyName}"`,
        text: "",
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("DeleteSurvey", this.surveyform)
            .then(() => {
              Swal.fire({
                icon: "success",
                text: `ลบ "${this.surveyform.surveyName}" เรียบร้อยแล้ว`,
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                if (this.$route.name !== "survey") {
                  this.$router.push({
                    name: "survey",
                  });
                }
              });
            })
            .catch((err) => {
              let errMsg =
                err.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์ลบ survey"
                  : "ไม่สามารถลบได้";
              Swal.fire({
                icon: "error",
                text: errMsg,
                title: "",
              }).then(() => {
                this.$store.dispatch("getSurvey");
                this.$store.commit("ToggleLoading");
                if (err.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        } else {
          this.getSurveyByID();
        }
      });
    },
    ToggleAutoForm() {
      Swal.fire({
        title: `ยืนยันการ${
          !this.surveyform.welcome_theme.default.autoform ? "ปิด" : "เปิด"
        }แบบสอบถามแบบไม่ระบุตัวตน`,
        text: "",
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.UpdateSurvey();
        } else {
          this.surveyform.welcome_theme.default.autoform =
            !this.surveyform.welcome_theme.default.autoform;
        }
      });
    },
    Schedule(data) {
      console.log(data);
      let date_start = data.date_start;
      let start_h = data.start_h;
      let start_m = data.start_m;
      let date_end = data.date_end;
      let end_h = data.end_h;
      let end_m = data.end_m;
      this.surveyform.surveyDatetimeStart = `${date_start}T${start_h}:${start_m}`;
      this.surveyform.surveyDatetimeEnd = `${date_end}T${end_h}:${end_m}`;
      if (!this.surveyform.enableSchedule) {
        this.surveyform.surveyDatetimeStart = new Date().toISOString();
        this.surveyform.surveyDatetimeEnd = new Date().toISOString();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
